export const Categories = `query Categories {
  pCategories(sort: "sortNum:desc", where: { isPublish: true }) {
    id
    name

    # 路由名称
    routerName
    
    projects(where: { isPublish: true }) {
      id
    }
  }
}`
